export const PROCEDURE_CODE_XZERO = "XZERO";
export const PROCEDURE_CODE_B4034 = "B4034";
export const PROCEDURE_CODE_B4035 = "B4035";
export const PROCEDURE_CODE_B4036 = "B4036";
